import {
  EpidemiologyDataOptions,
  EpidemiologyExportRequest,
  PrevProjDataOptions,
  PrevProjExportRequest,
} from "@/dashboard-api-types/api/epidemiologyData.types";
import { LocCodesInput, normalizeLocCodes } from "./normalizeLocCodes";
import { formatOptionsBody } from "./formToOptsBody";
import { formatPrevProjOptionsBody } from "./formToPrevProjBody";

export type EpidemiologyExportInput = EpidemiologyDataOptions & LocCodesInput;
export type PrevProjExportInput = PrevProjDataOptions & LocCodesInput;

export function formatEpidemiologyExportRequest(
  body: EpidemiologyExportInput
): EpidemiologyExportRequest {
  const { locCode, locCodes, ...options } = body;
  const formattedOptions = formatOptionsBody(options) ?? {};
  return { ...formattedOptions, locCodes: normalizeLocCodes({ locCode, locCodes }) };
}

export function formatPrevProjExportRequest(body: PrevProjExportInput): PrevProjExportRequest {
  const { locCode, locCodes, ...options } = body;
  const formattedOptions = formatPrevProjOptionsBody(options) ?? {};
  return { ...formattedOptions, locCodes: normalizeLocCodes({ locCode, locCodes }) };
}
